import './App.css';
import { useEffect, useState } from 'react';

function App() {
  const words = {
    1: ["b", "l", "a", "z", "e"],
    2: ["c", "r", "i", "s", "p"],
    3: ["f", "l", "i", "n", "t"],
    4: ["g", "l", "o", "v", "e"],
    5: ["p", "r", "i", "d", "e"],
    6: ["s", "l", "i", "n", "g"],
    7: ["t", "r", "u", "n", "k"],
    8: ["w", "h", "a", "l", "e"],
    9: ["b", "r", "i", "n", "k"],
    10: ["c", "l", "o", "a", "k"],
    11: ["d", "r", "i", "f", "t"],
    12: ["f", "l", "o", "u", "r"],
    13: ["g", "r", "a", "i", "n"],
    14: ["h", "a", "s", "t", "e"],
    15: ["j", "o", "l", "l", "y"],
    16: ["k", "n", "o", "c", "k"],
    17: ["l", "a", "t", "c", "h"],
    18: ["m", "i", "r", "t", "h"],
    19: ["n", "o", "v", "e", "l"],
    20: ["o", "u", "n", "c", "e"],
    21: ["p", "l", "a", "n", "e"],
    22: ["q", "u", "i", "r", "k"],
    23: ["r", "a", "i", "s", "e"],
    24: ["s", "h", "i", "n", "e"],
    25: ["t", "h", "u", "m", "p"],
    26: ["u", "n", "i", "t", "e"],
    27: ["v", "i", "p", "e", "r"],
    28: ["w", "o", "r", "s", "t"],
    29: ["x", "e", "n", "o", "n"],
    30: ["y", "o", "u", "t", "h"],
    31: ["z", "e", "a", "l", "s"],
    32: ["c", "l", "i", "n", "k"],
    33: ["s", "p", "i", "c", "e"],
    34: ["b", "l", "i", "n", "k"],
    35: ["c", "r", "a", "n", "e"],
    36: ["d", "u", "s", "t", "y"],
    37: ["f", "r", "e", "s", "h"],
    38: ["g", "u", "s", "h", "y"],
    39: ["h", "u", "m", "i", "d"],
    40: ["j", "u", "m", "p", "s"]
  };
  
   
  const [answer, setAnswer] = useState(() => {
    const keys = Object.keys(words);
    const randomKey = keys[Math.floor(Math.random() * keys.length)];
    return words[randomKey];
  });
   
  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
 const [pressedLetter, setPressedLetter] = useState(null);
  const [letters, setLetters] = useState(['A','B','C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N',
    'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']);
  const [boxes, setBoxes] = useState([]);
  const [count, setCount] = useState(0)
  const [gameOver, setGameOver] = useState(false);
  
  

  useEffect(() => {
    function handleKeyDown(event) {
      
         const key = event.key.toUpperCase();
       if (/^[A-Z]$/.test(key) && count <= 4 && !gameOver) {
        setBoxes(prev => [...prev, {letter: key, status: null}])
        setCount(prev => prev + 1)
       }
      
       if (event.key === "Backspace" && count > 0) {
        setBoxes(prev => prev.slice(0, -1));
        setCount(prev => prev - 1)
       }

       if (event.key === "Enter") {
         checkAnswer()
       }
      
      console.log(event)
    }
   
      window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
    
  }, [count]);


   function keySelected(index) {  
      if(count <= 4 && !gameOver) {
        const selectedLetter = letters[index];
      setBoxes(prev => [...prev, {letter: selectedLetter, status: null}])
      setCount(prev => prev + 1)
      
      }
   }

  

   function removeLetter() {
    if (count > 0) {
      setBoxes(prev => prev.slice(0, -1));
      setCount(prev => prev - 1)
    }      
  }
  
   function checkAnswer() {
    if (count === 5) {
      const normalizedGuess = boxes.slice(-5).map(box => box.letter.toLowerCase());
      const updatedBoxes = [...boxes];
  
      // Step 1: Copy the answer to keep track of matched letters
      const answerCopy = [...answer];
      const guessStatuses = Array(5).fill(null);
  
      // Step 2: First pass — mark greens and remove matched letters from answerCopy
      normalizedGuess.forEach((letter, index) => {
        if (letter === answerCopy[index]) {
          guessStatuses[index] = 'green';
          answerCopy[index] = null; // Mark as used
        }
      });
  
      // Step 3: Second pass — mark yellows if letter exists in answerCopy
      normalizedGuess.forEach((letter, index) => {
        if (!guessStatuses[index] && answerCopy.includes(letter)) {
          guessStatuses[index] = 'yellow';
          answerCopy[answerCopy.indexOf(letter)] = null; // Mark as used
        } else if (!guessStatuses[index]) {
          guessStatuses[index] = 'red';
        }
      });
  
      // Step 4: Apply statuses
      for (let i = 0; i < 5; i++) {
        updatedBoxes[boxes.length - 5 + i].status = guessStatuses[i];
      }

      const allGreen = guessStatuses.every(status => status === 'green');
      if (allGreen) {
        setGameOver(true);
      }
  
      setBoxes(updatedBoxes);
      setCount(0);
    }
  }

  function resetGame() {
    setBoxes([]);
    setCount(0);
    setGameOver(false);
  
    const keys = Object.keys(words);
    const randomKey = keys[Math.floor(Math.random() * keys.length)];
    setAnswer(words[randomKey]);
  }
  

  return (
    <div className="container">
     <h2 className='header'>Wordle</h2>
     <div className='grid'>
        {[...Array(30)].map((_, index) => {
          const box = boxes[index];
          const boxClass = `box ${box?.status || ''}`
          return (
            <div className={boxClass} key={index}>
            {box?.letter || ''} 
          </div> 
          )
      })}
     </div>
     <div className='keyboard-container'>
     <div className='keyboard'>
        {[...letters].map((_, index) => (
          <button  onClick={() => keySelected(index)} className='letter'>
            {_}
          </button>
        ))}
     </div>
     <div className='btn-container'>
     <button onClick={removeLetter} className='delete-btn'>Delete</button>
     <button onClick={checkAnswer} className='submit-btn'>submit</button>
     <button onClick={resetGame}>New Game</button>
     </div>
     </div>
     
    </div>
  );
}
export default App;

